import * as cloudinary from './cloudinary';
import * as staticProvider from './static';

export default {
  cloudinary,
  static: staticProvider,
};
